export default __webpack_public_path__ + "static/media/Remolquede SúperLujo3.0ab8dae0.png";